import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../../data/content";
import { Reveal } from "./Reveal";

export const Testimonials = () => (
  <section id="opiniones" data-testid="testimonials-section" className="relative py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <span className="text-xs uppercase tracking-[0.3em] text-[#C5A059]">Opiniones</span>
        <h2 className="mt-4 font-serif text-4xl sm:text-5xl md:text-6xl text-[#F3EFE7] tracking-tight max-w-3xl">
          Quienes ya confiaron en mí
        </h2>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 2) * 0.1}>
            <figure data-testid={`testimonial-${i}`}
              className="h-full rounded-2xl border border-[#C5A059]/20 bg-[#1A0B2E]/40 p-8 backdrop-blur-sm">
              <Quote className="text-[#C5A059]/60" size={28} />
              <blockquote className="mt-4 text-lg text-white/85 font-serif italic leading-relaxed">"{t.text}"</blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <span className="h-9 w-9 rounded-full bg-[#C5A059] text-[#05030A] grid place-items-center font-serif">
                  {t.name.charAt(0)}
                </span>
                <span className="text-sm text-white/70">
                  <span className="text-[#F3EFE7]">{t.name}</span> · {t.place}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
